import { Item } from './db-item';
import { LocationRef } from './db-location';
import { OrderUser, UserRef } from './db-user';
import { Metadata } from './db';
import { ObjectId } from 'mongodb';

export enum ItemStatus {
  Pending = 'pending',
  Rejected = 'rejected',
  Approved = 'approved',
  Prepared = 'prepared',
  Cancelled = 'cancelled',
  Collected = 'collected',
  Recalled = 'recalled',
  Returned = 'returned',
  Refurbish = 'refurbish',
  Discarded = 'discarded',
}

type ItemStatusTypes = `${ItemStatus}`;

export enum OrderStatus {
  Completed = 'completed',
  Pending = 'pending',
}

export enum OrderType {
  Inventory = 'inventory',
  Order = 'order',
}

export type ItemStatusReasons = {
  pending: never;
  rejected: never;
  approved: never;
  prepared: 'pickup' | 'handoff';
  cancelled: never;
  collected: never;
  recalled: never;
  returned: never;
  refurbish: 'damaged' | 'recycle';
  discarded: 'discarded' | 'lost' | 'giveaway';
};

export type OrderItem = {
  _orderItemId: ObjectId;
  item: Item;
  lastStatus: ItemStatus;
  statusHistory: StatusHistory<any>[];
} & Metadata;

export type StatusHistory<T extends ItemStatusTypes> = {
  user: UserRef;
  status: T;
  returnedToStock?: boolean;
  reason?: ItemStatusReasons[T];
  _warehouseId?: ObjectId;
} & Metadata;

export type OrderComment = {
  message: string;
  user: UserRef;
  _orderItemId?: ObjectId;
  status?: ItemStatus;
} & Metadata;

export interface OrderRef {
  _id: ObjectId;
  slug: string;
  type: OrderType;
}

export type Order = OrderRef & {
  type: OrderType;
  location: LocationRef;
  onHold?: boolean;
  requestedFor: UserRef;
  requestedBy: OrderUser;
  _invitationId?: ObjectId;
  status: OrderStatus;
  items: OrderItem[];
  comments: OrderComment[];
} & Metadata;
